import groq from 'groq'

export default ({ category }) => groq`
  *[
    _type=="testimonial" &&
    (productCategories[]->slug.current)[@ in ["${category}"]]
  ][] | order(_createdAt asc) {
    ...
  }
`
